import "./IconTile.scss";

import clsx from "clsx";
import { FCC } from "types";

interface Props {
  icon?: JSX.Element;
  label?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  dataTestId?: string;
  isMobile?: boolean;
  variant?: "default" | "sim-selection-variant";
}

export const IconTile: FCC<Props> = ({
  icon,
  label,
  selected,
  disabled,
  onClick,
  dataTestId = "icon-tile",
  isMobile,
  variant = "default",
}) => {
  const isSimSelectionVariant = variant === "sim-selection-variant";

  return (
    <button
      aria-label={label}
      {...(disabled ? { disabled: true } : {})}
      className={clsx(
        "icon-tile",
        isSimSelectionVariant && "icon-tile--sim-selection-variant",
        selected && "selected",
        disabled && "opacity-50",
        isMobile && [
          "h-auto w-full flex-row px-8 py-6",
          isSimSelectionVariant && "items-center justify-start gap-4",
        ],
      )}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {icon && (
        <div
          className={clsx(
            "icon-container",
            isMobile &&
              (isSimSelectionVariant ? "shrink-0 items-center" : "mr-2"),
          )}
        >
          {icon}
        </div>
      )}
      <p
        className={clsx(
          "label-container",
          isMobile && [
            "!w-full !justify-start !whitespace-normal !text-start",
            isSimSelectionVariant && "flex-1",
          ],
        )}
      >
        {label}
      </p>
    </button>
  );
};
